enum Gender {
  Female = 1,
  Male = 2
}

enum CorrespondingAddress {
  Home = 1,
  Office = 2
}

enum Status {
  All = -1,
  Inactive = 1,
  Active = 0
}

enum YesorNo {
  No = 0,
  Yes = 1,
  Na = -1
}
enum LongorShort {
  Short = 1,
  Long = 2
}

enum SelectType {
  All = -1,
  Other = 0
}

enum TrueOrFalse {
  All = -1,
  False = 0,
  True = 1
}

enum ApplicationType {
  BasicTrainingApplication = 1,
  BasicTrainingCompletionForm = 2
}

export const commonEnums = {
  Gender,
  Status,
  CorrespondingAddress,
  YesorNo,
  LongorShort,
  SelectType,
  TrueOrFalse,
  ApplicationType
}
